import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentCarousel3UpVideo";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length) {
        return ["The LineupContentCarousel3UpVideo module has no items"];
    }

    const errorMessages = checkItemArrayIntegrity(items, ["headline"]);
    errorMessages.push(...checkMediaIntegrity(items, MEDIA_PRIORITY));
    return errorMessages;
}
